import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { REMOVE_BRANDING_BANNER } from '../../_core/common/constants/PurchaseMotionLocations';
import { track } from '../../_core/common/eventTracking/tracker';
import { PRICING_PAGE_REDIRECT } from '../../_core/purchaseMotions/PurchaseMotionTypes';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIPurchaseMotionButton from '../../button/UIPurchaseMotionButton';
import { getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import BuiltOnHubSpotBadge from './BuiltOnHubSpotBadge';
import DefaultBanner from './DefaultBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RemoveBrandingBanner = ({
  upgradePoint,
  marginStyle,
  'data-test-id': dataTestId = 'locked-feature-banner'
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradePoint);
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint]);
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.descriptions);
  return /*#__PURE__*/_jsx(DefaultBanner, {
    marginStyle: marginStyle,
    dataTestId: dataTestId,
    icon: /*#__PURE__*/_jsx(BuiltOnHubSpotBadge, {}),
    titleText: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerTitle
    }),
    subtext: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerSubtitle
    }),
    button: /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      upgradeData: upgradeData,
      location: REMOVE_BRANDING_BANNER,
      level: 1,
      size: "extra-small",
      purchaseMotions: [PRICING_PAGE_REDIRECT],
      "data-test-id": "upgrade-button",
      isUpgradePoint: true,
      goToUpgradePage: true,
      truncate: false,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    })
  });
};
export default RemoveBrandingBanner;